<script>
import mixins from 'vuetify/lib/util/mixins'
import VSelectList from 'vuetify/lib/components/VSelect/VSelectList'
import { VListItem, VListItemContent, VListItemTitle } from 'vuetify/lib/components'
import { EMenuListItem } from '../../EMenu'

const baseMixins = mixins(VSelectList)
/* @vue/component */

export default baseMixins.extend().extend({
  name: 'ESelectList',
  // extends: VSelect,
  methods: {
    genTileContent(item, index = 0) {
      return this.genFilteredText(this.getText(item))
    },
    genTile({ item, index, disabled = null, value = false }) {
      if (!value) value = this.hasItem(item)

      if (item === Object(item)) {
        disabled = disabled !== null ? disabled : this.getDisabled(item)
      }

      const tile = {
        attrs: {
          // Default behavior in list does not
          // contain aria-selected by default
          'aria-selected': String(value),
          id: `list-item-${this._uid}-${index}`,
          role: 'option',
        },
        on: {
          mousedown: (e) => {
            // Prevent onBlur from being called
            e.preventDefault()
          },
          click: () => disabled || this.$emit('select', item),
        },
        props: {
          activeClass: this.tileActiveClass,
          disabled,
          inputValue: value,
          action: this.action && !this.hideSelected && this.items.length > 0 ? 'checkbox' : null,
          ripple: false,
        },
      }

      if (!this.$scopedSlots.item) {
        return this.$createElement(EMenuListItem, tile, [
          this.action && !this.hideSelected && this.items.length > 0 ? this.genAction(item, value) : null,
          this.genTileContent(item, index),
        ])
        // return this.$createElement(EMenuListItem, tile, [
        //   this.action && !this.hideSelected && this.items.length > 0 ? this.genAction(item, value) : null,
        //   this.genTileContent(item, index),
        // ])
      }

      const parent = this
      const scopedSlot = this.$scopedSlots.item({
        parent,
        item,
        attrs: { ...tile.attrs, ...tile.props },
        on: tile.on,
      })
      return this.needsTile(scopedSlot) ? this.$createElement(EMenuListItem, tile, scopedSlot) : scopedSlot
    },
  },
})
</script>
